import React, { useContext, useEffect } from 'react';
import { Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom';
import LoginForm from '../components/LoginForm';
import Dashboard from '../pages/Dashboard';
import Clients from '../pages/Clients';
import Packages from '../pages/Packages';
import ClientDetails from '../pages/ClientDetails';
import { AuthContext } from '../context/AuthContext';

const RequireAuth = ({ children }) => {
  const { isAuthenticated } = useContext(AuthContext);
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  return children;
};

const RoutesConfig = () => {
  const { isAuthenticated, logout } = useContext(AuthContext);
  const navigate = useNavigate();

  // When logout route hit
  useEffect(() => {
    if (window.location.pathname === '/logout') {
      logout();
      navigate('/', { replace: true });
    }
  }, [logout, navigate]);

  // Redirect from home page navigation
  useEffect(() => {
    const currentPath = window.location.pathname;
    if (isAuthenticated && (currentPath === '/' || currentPath === '')) {
      navigate('/dashboard', { replace: true });
    }
  }, [isAuthenticated, navigate]);

  return (
    <Routes>
      <Route path="/" element={isAuthenticated ? <Navigate to="/dashboard" replace /> : <LoginForm />} />
      <Route path="/dashboard" element={<RequireAuth><Dashboard /></RequireAuth>} />
      <Route path="/clients" element={<RequireAuth><Clients /></RequireAuth>} />
      <Route path="/packages" element={<RequireAuth><Packages /></RequireAuth>} />
      <Route path="/clients/:clientId" element={<RequireAuth><ClientDetails /></RequireAuth>} />

      <Route path="/logout" element={null} />
    </Routes>
  );
};

export default RoutesConfig;
